<template>
  <div>
    <div class="carousel_com container_w">
        <div class="carousel_box">
            
            <router-link 
            :to="{path:'/interlayer',query: {list: baseUrl[slideIndex]}}" v-if="baseUrl[slideIndex].fileText">
                <h3>{{baseUrl[slideIndex].title}}</h3>
            </router-link>
            <a :href="baseUrl[slideIndex].linkUrl?baseUrl[slideIndex].linkUrl:'javascript:;'" v-else>
                <h3>{{baseUrl[slideIndex].title}}</h3>
            </a>

            <router-link 
            :to="{path:'/interlayer',query: {list: baseUrl[slideIndex]}}" v-if="baseUrl[slideIndex].fileText">
                <p>{{baseUrl[slideIndex].remark}}</p>
            </router-link>
            <a :href="baseUrl[slideIndex].linkUrl?baseUrl[slideIndex].linkUrl:'javascript:;'" v-else>
                <p>{{baseUrl[slideIndex].remark}}</p>
            </a>
            <ul>
                <li v-for="(item,index) in baseUrl" :key="index" @click="golist(index)" :class="{'slide_active':slideIndex==index}"></li>
            </ul>
        </div>
    </div>
    <!-- autoplay -->
    <el-carousel ref="carousel" trigger="click" arrow="never" indicator-position="none" height="500px" :autoplay="autoplay" @change="afterChange">
      <el-carousel-item v-for="(item,index) in baseUrl" :key="index" class="bag_style">
        <router-link 
            :to="{path:'/interlayer',query: {list: item}}" v-if="item.fileText">
            <img :src="item.imgUrl" :alt="item.title" style="width:100%;"/>
        </router-link>
        <a :href="item.linkUrl?item.linkUrl:'javascript:;'" v-else>
            <img :src="item.imgUrl" :alt="item.title" style="width:100%;"/>
        </a>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>

export default {
  components: {
    
  },
  name: 'Carousel',
  data () {
    return {
        slideIndex:0,
        baseUrl:[],
        autoplay: true
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    afterChange(current){
        this.slideIndex = current
    },
    // beforeChange(from, to){
    //     // console.log(from)
    //     // console.log(to)
    // },
    golist(i){
        this.slideIndex = i
        if (this.$refs.carousel && this.$refs.carousel.setActiveItem) {
            this.$refs.carousel.setActiveItem(i)
        }
    }
  },
  filters: {

  },
  computed: {

  },
  created () {
    let OfficeID = this.$Utils.getSession('COUNTRY_OfficeID')
    let carouselList = []
    ADJSON.forEach((i)=>{
        if(i.advPositionId == 'indexCarousel' && i.officeIdStr.indexOf(OfficeID)>-1){
            carouselList.push(i)
        }
    })
    this.baseUrl = carouselList
  },
  mounted () {
    
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .carousel_com{
        position: relative;
    }
    .carousel_box{
        padding: 0 32px;
        width:496px;
        height:248px;
        background:rgba(216,0,15,.79);
        position: absolute;
        top: 64px;
        left: 0;
        z-index: 1;
        h3{
            font-size:24px;
            color:rgba(255,255,255,1);
            line-height:29px;
            margin: 46px 0 16px 0;
        }
        p{
            font-size:16px;
            color:rgba(255,255,255,1);
            line-height:19px;
            margin-bottom: 48px;
        }
        ul{
            position: absolute;
            bottom: 45px;
            right: 32px;
            transition:  1s cubic-bezier(0.075, 0.82, 0.165, 1);
            li{
                float: left;
                width:8px;
                height:4px;
                background:rgba(255,255,255,.5);
                border-radius:3px;
                margin-left: 8px;
                cursor: pointer;
                transition:  1s cubic-bezier(0.075, 0.82, 0.165, 1);
            }
            .slide_active{
                width:16px;
                height:4px;
                background:rgba(255,255,255,1);
                border-radius:3px;
            }
        }
    }
    .el-carousel{
        width: 100%;
        overflow: hidden;

        .el-carousel__container{
            width: 100%;
        }

        .el-carousel__item{
            width: 100% !important;
            max-width: 100%;

            > div{
                width: 100%;
                height: 500px;
            }

            img{
                width: 100%;
                max-width: 100%;
                min-width: auto;
                height: 100%;
                object-fit: cover;
                display: block;
                margin: 0;
            }
        }

        .el-carousel__item.is-active{
            width: 100% !important;
            height: 500px;
            position: relative;
            z-index: 0;

            img{
                width: 100%;
                max-width: 100%;
                min-width: auto;
                height: 100%;
                object-fit: cover;
                display: block;
                margin: 0;
            }
        }
    }
    /* Ensure the slide content wrapper from template keeps fixed height */
    .bag_style{
        height: 500px;
        overflow: hidden;
    }
    /* Force higher-specificity rules for deployed environments */
    // .ant-carousel /deep/ .slick-slide,.ant-carousel /deep/ .slick-slide img{
    //     height: 500px;
    // }
</style>
